import { Component } from "react"
import PropTypes from "prop-types"

import SectionWithIcon from "../static_applet_composer/section_with_icon"
import TandaComposer from "../static_applet_composer/tanda_composer"
import TandaFields from "../static_applet_composer/tanda_fields"
import InlineErrors from "shared/components/inline_errors"

import { pluralizeStepType } from "shared/lib/utils"

export default class TandaEditor extends Component {
  state = {
    tandaSelectionError: [],
  }

  handleTandaSelect = (code, selectedTanda) => {
    if (this.props.alreadySelectedTandas.includes(selectedTanda.module_name)) {
      this.setState({
        tandaSelectionError: [
          `"${selectedTanda.name}" is already selected. We currently support only one configuration of each unique ${this.props.tanda.type} per feature`,
        ],
      })
      return
    } else {
      this.setState({ tandaSelectionError: [] })
    }
    this.props.handleTandaSelect({
      ...selectedTanda,
      code,
      type: this.props.tanda.type,
      fields: (
        selectedTanda.action_fields ||
        selectedTanda.query_fields ||
        selectedTanda.trigger_fields ||
        []
      ).map(f => ({
        name: f.name,
        custom_label: f.label || "",
        default_value: null,
        hidden: f.hideable || false,
      })),
    })
  }

  render() {
    const { contextChannelId, serviceTandaDetails, tanda, errors, allStepsOfType, newConfigMode } = this.props
    const selector = `applet_${pluralizeStepType(tanda.type)}/${
      tanda.indexByType
    }/fields`
    const fieldErrors = errors.select(selector)

    let tandaOption
    if (tanda[`${tanda.type}_fields`]) {
      tandaOption = tanda
    } else if (newConfigMode) {
      tandaOption = allStepsOfType.find(
        t => t.module_name === tanda.module_name
      )
    } else {
      tandaOption =
        tanda.service &&
        tanda.service[pluralizeStepType(tanda.type)] &&
        tanda.service[pluralizeStepType(tanda.type)].find(
          t => t.module_name === tanda.module_name
        )
    }

    const fieldsByName = (
      (tandaOption && tandaOption[`${tanda.type}_fields`]) ||
      []
    ).reduce(
      (acc, cur) => ({
        ...acc,
        [cur.name]: cur,
      }),
      {}
    )

    const ingredientsMetadata = {}

    const icon = serviceTandaDetails &&
      serviceTandaDetails.lrg_monochrome_image_url && (
        <img
          className="applet-composer-sidebar-service-logo"
          src={serviceTandaDetails.lrg_monochrome_image_url}
          title={serviceTandaDetails.name}
          alt={serviceTandaDetails.name}
        />
      )

    const iconBackgroundColor =
      serviceTandaDetails &&
      serviceTandaDetails.brand_color &&
      `#${serviceTandaDetails.brand_color}`

    return (
      <SectionWithIcon
        icon={icon}
        iconBackgroundColor={iconBackgroundColor}
        last={this.props.last}
      >
        <div className="fieldset composer-fieldset" data-code={tanda.code}>
          <InlineErrors errors={this.state.tandaSelectionError} />
          <TandaComposer
            contextChannelId={contextChannelId}
            services={[]}
            onServiceSelect={() => {}}
            selectedService={serviceTandaDetails}
            selectedServiceTandas={
              newConfigMode
                ? allStepsOfType
                : serviceTandaDetails[pluralizeStepType(tanda.type)]
            }
            onTandaSelect={this.handleTandaSelect.bind(null, tanda.code)}
            selectedTanda={tanda.module_name ? tanda : null}
            onRemoveTanda={() => {
              this.props.onRemoveTanda(tanda.type, tanda.code)
            }}
            tandaType={tanda.type}
            appletType="dynamic"
            enabled={!this.props.appletPublished}
            required={tanda.required}
            configUI
          >
            <TandaFields
              appletFields={tanda.fields}
              fieldsByName={fieldsByName}
              onChange={this.props.onUpdateFields}
              onInvalidResolution={() => {}}
              ingredientsMetadata={ingredientsMetadata}
              errors={fieldErrors}
              invalidRemoteFields={{}}
              canEditHiddenField={!this.props.appletPublished}
              canEditHiddenValueField={true}
            />
          </TandaComposer>
          {newConfigMode && (
            <button
              className="button-tertiary"
              onClick={this.props.onSaveTanda}
            >
              Save
            </button>
          )}
        </div>
      </SectionWithIcon>
    )
  }
}

TandaEditor.propTypes = {
  appletPublished: PropTypes.bool.isRequired,
  contextChannelId: PropTypes.string.isRequired,
  serviceTandaDetails: PropTypes.object.isRequired,
  tanda: PropTypes.shape({
    type: PropTypes.string.isRequired,
    fields: PropTypes.array,
    indexByType: PropTypes.number,
  }),
  handleTandaSelect: PropTypes.func.isRequired,
  onRemoveTanda: PropTypes.func.isRequired,
  last: PropTypes.bool.isRequired,
  onUpdateFields: PropTypes.func.isRequired,
  errors: PropTypes.object,
  alreadySelectedTandas: PropTypes.array,
  allStepsOfType: PropTypes.array,
  newConfigMode: PropTypes.bool,
  onSaveTanda: PropTypes.func,
}

TandaEditor.defaultProps = {
  newConfigMode: false,
  onSaveTanda: () => {},
}
